'use strict';

class CreditNoteResend {
    constructor($scope, $location, $routeParams, originatorService, recipientService, creditNoteService, validationService, shipmentMethodsService, Notification, StoreService) {
        this.$scope = $scope;
        this.$location = $location;
        this.originatorService = originatorService;
        this.creditNoteService = creditNoteService;
        this.validationService = validationService;
        this.shipmentMethodsService = shipmentMethodsService;
        this.recipientService = recipientService;
        this.Notification = Notification;

        this.invoiceNumber = $routeParams.number;

        this.cart = new StoreService('id');
    }

    $onInit() {
        this.alert = {};
        this.options = {
            ehf: false
        };
        this.hotmailWarning = false;

        // this.addAdminFee();

        this.invoice = {
            shipment: {
                ehf: {},
                paper: {},
                email: [{
                    address: null,
                    customMessage: null
                }],
                sms: [{
                    mobileNumber: null
                }],
                copy: {
                    email: [{
                        address: null,
                        customMessage: null
                    }]
                }
            }
        };

        this.method = {
            ehf: false,
            email: true,
            paper: false
        };
        this.copy = {
            sms: false,
            email: false
        };

        this.$scope.$watch('$ctrl.copy.email', (val) => {
            const item = {
                id: 'copyEmail',
                price: this.prices.creditNote.emailCopy,
                name: 'Kopi på e-post'
            };

            if (val) {
                this.cart.add(item);
            } else {
                this.cart.remove(item);
            }
        });

        this.$scope.$watch('$ctrl.copy.sms', (val) => {
            const item = {
                id: 'sms',
                price: this.prices.common.sms,
                name: 'SMS'
            };

            if (val) {
                this.cart.add(item);
            } else {
                this.cart.remove(item);
            }
        });

        this.$scope.$watchGroup([
            '$ctrl.hotmailWarning',
            '$ctrl.invoice.shipment.email[0].address'
        ], (val) => {
            if (val[0]) {
                if (val && !this.validationService.isMicrosoft(val[1]).valid) {
                    this.alert = {
                        type: 'warning',
                        message: this.validationService.isMicrosoft(val[1]).message
                    };
                } else {
                    this.alert = {};
                }
            }
        });

        this.load();
    }

    load() {
        // load draft
        this.creditNoteService.get(this.invoiceNumber)
            .then((json) => {
                if (!json.data.endUserMessage) {
                    return json.data;
                } else {
                    this.Notification.error(json.data.endUserMessage);
                }
            })
            .then((resp) => {
                this.invoice = resp;

                // assign shipping again
                this.invoice.shipment = {
                    ehf: {},
                    paper: {
                        address1: resp.recipient.address.address1,
                        address2: resp.recipient.address.address2,
                        zip: resp.recipient.address.zip,
                        city: resp.recipient.address.city,
                        country: resp.recipient.address.country
                    },
                    email: [{
                        address: null,
                        customMessage: null
                    }],
                    sms: [{
                        mobileNumber: null,
                        message: `${this.originator.name} har sendt deg en kreditnota, se kreditnotaen på: `
                    }],
                    copy: {
                        email: [{
                            address: null
                        }]
                    }
                };

                // get originator settings
                this.originatorService.settings()
                    .then((json) => json.data)
                    .then((originator) => {
                        if (this.invoice.shipment) {
                            this.invoice.shipment.copy.email[0].address = originator.defaults.copy.email !== '' && originator.defaults.copy.email !== null ? originator.defaults.copy.email : originator.sendRegningContactEmail;
                        }

                        if (originator.defaults.copy.additionalEmails) {
                            originator.defaults.copy.additionalEmails.forEach((email) => {
                                this.invoice.shipment.copy.email.push({address: email, customMessage: null});
                            }, this);
                        }

                        if (originator.defaults.copy.suggest) {
                            this.copy.email = true;
                        }
                    });

                this.shipmentMethodsService.forReIssue('credit-note', this.invoiceNumber)
                    .then((methods) => {
                        methods.data.available.forEach((method) => {
                            this.options[method] = true;
                        }, this);

                        this.select(methods.data.default[0]);
                    });

                // add values to shipments
                if (this.invoice.shipment.email) {
                    this.invoice.shipment.email[0].address = this.invoice.recipient.email;
                }

                if (this.invoice.shipment.sms) {
                    this.invoice.shipment.sms[0].mobileNumber = this.invoice.recipient.mobile;
                }

                this.recipientService.get(this.invoice.recipient.number)
                    .then((json) => {
                        if (!json.data.endUserMessage) {
                            return json.data;
                        } else {
                            this.alert = {
                                type: 'error',
                                message: json.data.endUserMessage
                            };
                        }
                    })
                    .then((recipient) => {
                        // add values to shipments
                        if (this.invoice.shipment.email) {
                            this.invoice.shipment.email[0].address = recipient.contact.email;
                        }

                        if (recipient.defaultEmailCopy && recipient.defaultEmailCopy !== '') {
                            this.copy.email = true;

                            this.invoice.shipment.copy.email.push({
                                address: recipient.defaultEmailCopy,
                                customMessage: null
                            });
                        }
                    });
            });
    }

    addCopyEmail() {
        this.invoice.shipment.copy.email.push({address: null});
    }

    removeCopyEmail(index) {
        this.invoice.shipment.copy.email.splice(index, 1);

        //recalculate cart
        this.updateCartEmailCopy();

        // reindex
        this.invoice.shipment.copy.email.forEach((item, i) => {
            item.number = i + 1;
            return this.invoice.shipment.copy.email;
        });
    }

    countValidEmails() {
        var cnt = 0;
        this.invoice.shipment.copy.email.forEach(function (email) {
            var x = email.address;
            if ((x && x.length)) {
                cnt++;
            }
        });
        return cnt;
    }

    updateCartEmailCopy() {
        if (this.copy.email) {
            var count = this.countValidEmails();
            this.cart.add({
                id: 'copyEmail',
                price: this.prices.invoice.emailCopy * count,
                name: 'Kopi på e-post'
            }, true);
        }
    }

    addAdminFee() {
        if (this.prices.addAdminFee === true) {
            const admFeeItem = {
                id: 'admFee',
                price: 35,
                name: 'Administrasjonsgebyr'
            };

            this.cart.add(admFeeItem);
        }
    }

    updateCart(name) {
        // Cleanup first
        this.cart.reset();

        // this.addAdminFee();

        // Add back optionals if enabled
        if (this.copy.email) {
            var count = this.countValidEmails();
            this.cart.add({
                id: 'copyEmail',
                price: this.prices.invoice.emailCopy * count,
                name: 'Kopi på e-post'
            });
        }

        if (this.copy.sms) {
            this.cart.add({
                id: 'sms',
                price: this.prices.common.sms,
                name: 'SMS'
            });
        }

        // EHF
        if (name === 'ehf') {
            this.cart.add({
                id: 'ehf',
                price: this.prices.creditNote.ehf,
                name: 'EHF'
            });
        }

        // Paper
        else if (name === 'paper') {
            this.cart.add({
                id: 'paper',
                price: this.prices.creditNote.paper,
                name: 'Papir'
            });
        }

        // E-mail
        else if (name === 'email') {
            this.cart.add({
                id: 'email',
                price: this.prices.creditNote.email,
                name: 'E-post'
            });
        } else {
            return false;
        }
    }

    select(method) {
        // set inactive all
        this.method = {
            ehf: false,
            email: false,
            paper: false
        };

        // set selected active
        this.method[method] = true;

        // update cart
        this.updateCart(method);
    }

    send() {
        $('button.submit').prop('disabled', true);

        // create clone
        let clone = angular.copy(this.invoice);

        // reset shipment and attachments
        this.invoice.attachmentNumbers = [];
        this.invoice.shipment = {};

        // EHF
        if (this.method.ehf) {
            this.invoice.shipment.ehf = {};
        }

        // E-mail
        else if (this.method.email) {
            this.invoice.shipment.email = clone.shipment.email;
        }

        // Paper
        else if (this.method.paper) {
            this.invoice.shipment.paper = clone.shipment.paper;
            // disable attachments
            this.attachment = false;
        }

        // SMS
        if (this.copy.sms) {
            this.invoice.shipment.sms = [{
                mobileNumber: clone.shipment.sms[0].mobileNumber || null,
                message: clone.shipment.sms[0].message || null
            }];
        }

        // Copy email
        if (this.copy.email) {
            var emailCopies = [];

            //copy custom message from first item
            var customMessage = clone.shipment.copy.email[0].customMessage;

            clone.shipment.copy.email.forEach(function (email) {
                var x = email.address;
                if ((x && x.length)) {
                    emailCopies.push({
                        address: x || null,
                        customMessage: customMessage || null
                    });
                }
            });

            this.invoice.shipment.copy = {
                email: emailCopies
            };
        }

        // Send invoice
        this.creditNoteService.sendAgain(this.invoiceNumber, this.invoice.shipment)
            .then((json) => {
                // double check if the API returns with any errors
                if (json.data.errors) {
                    $('button.submit').prop('disabled', false);
                } else {
                    return json;
                }
            })
            .then(() => this.$location.path(`/kreditnota/${this.invoiceNumber}`))
            .catch(() => {
                $('button.submit').prop('disabled', false);
            });
    }
}

CreditNoteResend.$inject = ['$scope', '$location', '$routeParams', 'originatorService', 'recipientService', 'creditNoteService', 'validationService', 'shipmentMethodsService', 'Notification', 'StoreService'];

const creditNoteResend = {
    bindings: {
        originator: '<',
        prices: '<',
        countries: '<'
    },
    controller: CreditNoteResend,
    templateUrl: 'credit-note/resend.html'
};

angular
    .module('SendRegning')
    .component('creditNoteResend', creditNoteResend)
    .config(($routeProvider) => {
        $routeProvider
            .when('/kreditnota/:number/send', {
                title: 'Send kreditnota',
                template: '<credit-note-resend originator="$resolve.originator" prices="$resolve.prices" countries="$resolve.countries" />',
                resolve: {
                    prices: (commonService) => commonService.getPricesResend(),
                    originator: (originatorService) => originatorService.get().then((resp) => resp.data),
                    countries: (commonService) => commonService.getCountries()
                },
                noSidebar: true,
                overlay: true,
                secure: true
            });
    });
